import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {getUrl} from "../../../constants/urls";

export const userListURL = getUrl("listUser");

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_user"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_user"]},
];

export const PERMS_FOR_ACTIONS = ["change_user", "delete_user"];

export const LIST_HEADERS = [
  "username",
  "first_name",
  "last_name",
  "email",
  "is_active",
  "date_joined",
  "last_login",
];
